import {PlantDto} from '@domain/pom'
import {ApiClient} from '@hconnect/apiclient'

import {Plant, RequestFunc} from '../../types'

import {loggingDecorator} from './decorators'
import {convertSection} from './sections'

export const convertPlantData = (dto: PlantDto): Plant => ({
  id: dto.plantUpmId,
  name: dto.name,
  score: dto.scoring.score,
  completion: dto.scoring.completion,
  responsible: dto.responsible,
  sections: dto.sections.map(convertSection),
  timezone: dto.timezone,
  difficultySummaries: dto.scoring.difficultySummaries,
  guidanceLink: dto.guidanceLink
})

const getPlantImpl: RequestFunc<string, Plant> = async (plantId: string) => {
  const {data} = await ApiClient.axiosInstance.get<PlantDto>(`/pom-questionnaires/${plantId}`)
  return convertPlantData(data)
}
export const getPlant = loggingDecorator(getPlantImpl)

const assignPlantResponsibleImpl: RequestFunc<{plantId: string; userId: string}, void> = async ({
  plantId,
  userId
}) => {
  await ApiClient.axiosInstance.post(`/pom-questionnaires/${plantId}/responsible`, {userId})
}
export const assignPlantResponsible = loggingDecorator(assignPlantResponsibleImpl)

const downloadPlantSubmissionsImpl: RequestFunc<string, Blob> = async (plantId: string) => {
  const {data} = await ApiClient.axiosInstance.get<Blob>(
    `/pom-questionnaires/${plantId}/excel-sheet`,
    {
      responseType: 'blob'
    }
  )
  return data
}

export const downloadPlantSubmissions = loggingDecorator(downloadPlantSubmissionsImpl)
